const seleniumserver = (Prism) => {
  Prism.languages.seleniumserver = {
    comment: /^.*\[IOS_SYSLOG_ROW.*$/,
    // Command time must match 3 different formats:
    //  - something like [1.357][INFO]:
    //  - something like 2015-08-07 07:03:17:547
    //  - something like 23:31:45.071 INFO
    'command-time': /^(\[[\S]+\]:)|^\d+-\d+-\d+\s\d+:\d+:\d+:\d+|^\b(\d{2}:?)+([.\d])*\b/m,

    // It might be easier for the user to read the log if we try to highlight
    // the command/response flow
    outgoing: /\bCOMMAND\b\s\b.*\b|--> [A-Z]+ [\S]+/,
    incoming: /\bRESPONSE\b\s\b.*\b|<-- [A-Z]+ [\S]+/,
  };
};

seleniumserver.displayName = 'seleniumserver';
seleniumserver.aliases = [];

export default seleniumserver;
